<script>
	const model = require('model/model');
	const pageViewTracker = require('utilities/pageViewTracker');
	const onPageView = pageViewTracker.onPageView;
	const userContext = require('core/userContext');
	const utilities = require('utilities');
	const accountService = require('services/accountService');
	const pubsub = require('events/pubsub');
	const articleTabMixin = require('mixins/article-tab');
	const ReadWorksProduct = require('types/ReadWorksProduct');

	module.exports = {
		mixins: [articleTabMixin],
		components: {
			'vocabulary-image-list': require('components/vocabulary-image-list.vue').default,
			'question-text': require('components/question-text.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default,
			'toggle-buttons': require('components/toggle-buttons.vue').default,
			'tab-container': require('components/tab-container.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default,
			'article-selection': require('components/article-selection.vue').default
		},
		props: {
			article: {
				required: true
			},
			'route-context': {
				required: true
			},
			'show-aside': {
				type: Boolean,
				required: false,
				default: false
			},
			showTts: {
				type: Boolean,
				default: true
			},
			assessment: {
				required: true
			},
			fullOrExpress: {
				type: Object
			},
			setFullOrExpress: {
				type: Function
			}
		},
		data: function () {
			return {
				inProgress: false,
				questionShowAnswerFlags: {},
				toggleTooltip:
					'A full question set has 8-10 questions while an express set has 5 multiple-choice questions. Both scaffold important information toward understanding the main idea of the text. <a href="/teacher-guide/question-sets.html">Learn more…</a>'
			};
		},
		modelData: {
			answerKey: 'answerKey',
			userContext: 'userContext',
			questionsetsSection: 'questionsetsSection',
			contentSection: 'contentSection'
		},
		methods: {
			clickFullOrExpress(option) {
				const fullOrExpress = Object.assign({}, this.fullOrExpress, {
					[this.questionsetsSection]: option.value
				});

				this.setFullOrExpress(fullOrExpress);
			},
			updateFullOrExpressOnPropChange(qsets) {
				if (!Array.isArray(qsets)) return;

				const newFullOrExpress = Object.assign({}, this.fullOrExpress);
				if (this.assessment) {
					const expressLookup = (this.assessment.options.expressqs || []).reduce((lookup, qsid) => {
						const abridgedIds = this.assessment.product.questionSets[qsid] && this.assessment.product.questionSets[qsid].abridged_question_ids;
						if (abridgedIds && abridgedIds.length > 0) {
							lookup[qsid] = true;
						}
						return lookup;
					}, {});

					qsets.forEach(qset => {
						newFullOrExpress[qset.qsid] = expressLookup[qset.qsid] ? 'x' : 'f';
					});
				} else {
					qsets.forEach(qset => {
						newFullOrExpress[qset.qsid] = this.fullOrExpress[qset.qsid] || 'f';
					});
				}
				this.setFullOrExpress(newFullOrExpress);
			},
			sendAccountVerificationToken: function () {
				var self = this;

				self.inProgress = true;

				accountService
					.sendAccountVerificationToken()
					.then(function () {
						pubsub.publish('message-success', 'Email sent. Please check your inbox.');

						utilities.closeModals();
					})
					.catch(function (error) {
						if (error.code === 1092) {
							utilities.openModal('#verification-pending-error');
						} else {
							throw error;
						}
					})
					.fin(function () {
						self.inProgress = false;
					});
			},
			clickShowAllAnswers: function () {
				if (!userContext.isVerified()) {
					utilities.openModal('#verify-account');

					return;
				}

				model.set('answerKey', !model.get('answerKey'));
				onPageView(
					{
						answerKey: true
					},
					'answerKey'
				);
			},
			clickShowAnswer: function (q, state) {
				if (!q.answers || !q.answers.length) {
					return;
				}

				if (typeof state === 'undefined' && !userContext.isVerified()) {
					utilities.openModal('#verify-account');

					return;
				}

				if (typeof state !== 'boolean') {
					// state is being toggled through specific question button click
					state = !this.questionShowAnswerFlags[q.qid];

					// Fire PREVIEW_QUESTIONS
					let qid = q.qid;
					let qnum = q.qnum;
					let answerKey = state;

					onPageView(
						{
							qid,
							qnum,
							answerKey
						},
						'answerKey'
					);
				}
				this.questionShowAnswerFlags = Object.assign({}, this.questionShowAnswerFlags, {
					[q.qid]: state
				});
			},
			setArticleList() {
				const article = this.article;
				const articleList = article && article.articleList;

				if (articleList && !article.sr) {
					this.articleList = articleList.filter(a => a.questionSetsOrdered.some(qs => !qs.isVocab)).map(a => new ReadWorksProduct(a));
				}
			}
		},
		computed: {
			questionSets: function () {
				var article = this.selectedArticle,
					assessment = this.assessment,
					questionSets;

				if (assessment) {
					questionSets = [];

					article.questionSetsOrdered.forEach(function (qs) {
						if (qs.isVocab) {
							for (var i = 0; i < assessment.options.v.length; i++) {
								var vocabOption = assessment.options.v[i];

								if (vocabOption === qs.vocabularyWord) {
									questionSets.push(qs);

									break;
								}
							}
						} else {
							for (var j = 0; j < assessment.options.qs.length; j++) {
								var qsOption = assessment.options.qs[j];

								if (qsOption === qs.qsid) {
									questionSets.push(qs);

									break;
								}
							}
						}
					});
				} else {
					questionSets = article ? (article.questionSetsOrdered || []).filter(qs => !qs.isVocab) : null;
				}

				return questionSets;
			},
			questions() {
				if (this.selectedArticle) {
					const qsets = this.selectedArticle.questionSets;
					const qsid = this.questionsetsSection || Object.keys(qsets)[0];

					if (qsets && qsid in qsets) {
						const questions = this.selectedArticle.getQuestions(qsid, this.fullOrExpress[qsid] === 'x');

						questions.forEach((q, idx) => {
							if (!q.previewView) {
								q.showAnswer = this.questionShowAnswerFlags[q.qid];
								q.previewView = true; // Signals to question.vue that we are in the context of the preview view
								q.qnum = idx + 1;
							}
						});
						return questions;
					}
				}
				return [];
			},
			fullExpressOptions() {
				const qset = this.selectedArticle.questionSets[this.questionsetsSection];

				if (qset && qset.abridged_question_ids && qset.abridged_question_ids.length > 0) {
					return [
						{ value: 'f', label: 'Full' },
						{ value: 'x', label: 'Express' }
					].map(o =>
						Object.assign({}, o, {
							selected: o.value === this.fullOrExpress[this.questionsetsSection],
							disabled: this.assessment && o.value !== this.fullOrExpress[this.questionsetsSection]
						})
					);
				} else {
					return [{ value: 'f', label: 'Full', selected: true }];
				}
			},
			articleMap() {
				const article = this.article;
				let map = null;

				if (article && article.articles && !article.sr) {
					map = {};
					for (const uuid in article.articles) {
						map[uuid] = new ReadWorksProduct(article.articles[uuid]);
					}
				}

				return map;
			}
		},
		watch: {
			answerKey(answerKey) {
				this.questions.forEach(q => {
					this.clickShowAnswer(q, answerKey || false);
				});
			},
			questionSets(qsets) {
				this.updateFullOrExpressOnPropChange(qsets);
			},
			questionsetsSection(section) {
				if (section && !this.fullOrExpress[section]) {
					this.updateFullOrExpressOnPropChange(this.questionSets);
				}
			},
			contentSection() {
				const article = this.selectedArticle;
				const currentQuestionSet = article.questionSets && article.questionSets[this.questionsetsSection];

				if (!currentQuestionSet) {
					this.questionsetsSection = this.questionSets[0].qsid;
				}
			}
		},
		created() {
			const questionSets = this.questionSets;
			const articleList = this.articleList;

			if (questionSets.length === 0 && articleList) {
				this.contentSection = articleList[0].uuid;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.question-sets {
		.answer-button {
			float: right;
			margin-left: 5px;
			width: 5.7rem;

			&.disabled {
				pointer-events: none;
				opacity: 0.6;
				text-align: center;
				font-size: 0.7rem;
			}

			&.all-answer-button {
				width: 12rem;
				font-size: 0.9rem;
			}
		}

		.question-set-toggle-container {
			display: flex;
			align-items: center;
		}

		.question-set-tooltip {
			cursor: help;
		}

		footer {
			text-align: right;
			margin-top: 2.5em;
			border-top: 1px solid $c-grey;
			padding-top: 1.5em;
			font-size: 0.75rem;

			a {
				color: $c-slate-dark;

				&:hover {
					color: $c-slate-dark;
				}
			}
		}
	}

	.print-container .question-set {
		&.answer-key {
			.written-answer-sample.print-only {
				display: inherit;
			}

			.image-answer-answer .image-answer-correct-check {
				display: inherit;
			}
		}

		.written-answer-sample.print-only {
			display: none;
		}
	}

	@media only screen and (max-width: $bp-width-med) {
		.question-sets .answer-button.all-answer-button {
			margin-bottom: 0.7rem;
			float: none;
			margin-left: 0;
			display: block;
		}
	}
</style>
<template>
	<div class="wrapper row question-sets">
		<div
			:class="showAside ? 'large-8 columns' : 'large-12 columns'"
			aria-live="polite">
			<article-selection
				v-if="articleList.length > 0"
				:article="article"
				:selected-article="selectedArticle"
				:article-list="articleList"
				@article-selected="onArticleSelect"></article-selection>
			<tab-container
				v-if="selectedArticle && questionSets.length > 0"
				variant="pill-tabs"
				model-key="questionsetsSection"
				@tab-change="onSubTabChange"
				:default-tab="questionSets[0].qsid">
				<template>
					<button
						v-for="qs in questionSets"
						:key="qs.qsid"
						v-show="questionSets.length > 1"
						:data-tab="qs.qsid">
						{{ qs.title.replace('Vocabulary:', 'Vocab:') }}
					</button>
				</template>
			</tab-container>
			<section
				class="print-only print-warning print-answer-key"
				v-if="answerKey">
				<h2>To help keep ReadWorks answers secure, printing this content is not permitted. Sorry for the inconvenience.</h2>
			</section>
			<section
				v-if="questionsetsSection && selectedArticle.questionSets && selectedArticle.questionSets[questionsetsSection]"
				class="question-set margin-right-medium"
				:class="{
					'answer-key': answerKey,
					'print-hidden': answerKey
				}"
				ref="questionsetsSectionPanel"
				:data-panel="questionsetsSection">
				<header class="question-set-header">
					<h3 class="title">{{ selectedArticle.questionSets[questionsetsSection].title }}</h3>
					<div>
						<a
							v-if="!article.hasAnswerKey(questionsetsSection)"
							class="all-answer-button answer-button button disabled -small -outline">
							No Answers Provided
						</a>
						<a
							v-else
							v-on:click="clickShowAllAnswers()"
							class="all-answer-button answer-button button -small -outline">
							Show/Hide All Answers
						</a>
						<div
							class="question-set-toggle-container"
							v-if="fullExpressOptions.length > 1">
							<toggle-buttons
								@click-item="clickFullOrExpress"
								:options="fullExpressOptions">
							</toggle-buttons>
							<button
								class="question-set-tooltip button -link"
								v-tooltip="toggleTooltip">
								<info-icon aria-label="information"></info-icon>
							</button>
						</div>
					</div>
				</header>
				<div
					class="question-set-description rte"
					v-html="selectedArticle.questionSets[questionsetsSection].description"></div>
				<div
					class="directions"
					v-if="selectedArticle.questionSets[questionsetsSection].studentIntro">
					<question-text
						:content="selectedArticle.questionSets[questionsetsSection].studentIntro"
						:show-tts="showTts"
						:event-data="{ qsid: questionsetsSection, tag: 'student_intro' }">
					</question-text>
				</div>
				<template v-if="selectedArticle.questionSets[questionsetsSection].studentIntroImages">
					<vocabulary-image-list
						:images="selectedArticle.questionSets[questionsetsSection].studentIntroImages"
						:word="selectedArticle.questionSets[questionsetsSection].vocabularyWord">
					</vocabulary-image-list>
				</template>
				<div
					class="question-set-questions no-page-break"
					v-for="(question, questionIndex) in questions"
					:key="question.qid">
					<div
						class="directions"
						v-if="
							selectedArticle.questionSets[questionsetsSection].directions && selectedArticle.questionSets[questionsetsSection].directions[questionIndex + 1]
						">
						<span v-html="selectedArticle.questionSets[questionsetsSection].directions[questionIndex + 1]"></span>.
						<text-to-speech-player-simple
							v-if="showTts"
							:text="selectedArticle.questionSets[questionsetsSection].directions[questionIndex + 1]"
							:event-data="{ qsid: questionsetsSection, tag: 'question_instructions' }">
						</text-to-speech-player-simple>
					</div>
					<div :class="{ 'question-row': true, 'show-answer': !!questionShowAnswerFlags[question.qid] }">
						<a
							v-if="question.answers && question.answers.length > 0"
							@click="clickShowAnswer(question)"
							class="answer-button button -small -outline"
							:class="{ '-active': !!questionShowAnswerFlags[question.qid] }">
							Answer
						</a>
						<a
							v-else
							class="answer-button button disabled -small -outline">
							No Answer Provided
						</a>
						<question
							:product="selectedArticle"
							:index="question.qnum"
							:q="question"
							:qsid="questionsetsSection"
							:show-tts="showTts">
						</question>
					</div>
				</div>
			</section>
		</div>
		<template v-if="showAside">
			<div class="large-4 columns print-hidden">
				<article-aside
					:article="selectedArticle"
					:product="article"
					:is-question-set="true"
					:description="selectedArticle.description"
					:pair-text="selectedArticle.productType === 'P'"
					:search-query-string="routeContext.parsedPath.getQueryParam('search')"></article-aside>
			</div>
		</template>
		<modal id="verification-pending-error">
			<template slot="header-container">
				<h2>Verification pending</h2>
			</template>
			<template slot="content">
				<p>
					We've already sent you a verification email. Contact your email administrator or check your email account settings if you did not receive it.
				</p>
			</template>
		</modal>
		<modal id="verify-account">
			<template slot="header-container">
				<h2>Validate your Email</h2>
			</template>
			<template slot="content">
				<p>Only validated teachers or authorized adults may access answers.</p>
				<p>We’ll send you an email to confirm your identity. Click the link sent to {{ userContext.email }} to be granted access.</p>
				<button
					class="button -centered"
					v-bind:disabled="inProgress"
					v-on:click="sendAccountVerificationToken">
					Send Email
				</button>
			</template>
		</modal>
	</div>
</template>
